(($, Drupal) => {
  Drupal.behaviors.kafRecipeMedia = {
    attach: (context) => {

      var $body = $('body', context);
      if (!$body.hasClass('page-node-type-recipe')) {
        return;
      }

      $('#recipe__media-toggle', context).click(function(e) {
        e.preventDefault();
        $(this).toggleClass('media-hidden');
        if ($(this).hasClass('media-hidden')) {
          $('.recipe__instructions .embedded-entity', context).hide().parent('figure').hide();
          $(this).text('Show images');
          $(this).attr('aria-label', 'Show images and videos in recipe steps');
        } else {
          $('.recipe__instructions .embedded-entity', context).show().parent('figure').show();
          $(this).text('Hide images');
          $(this).attr('aria-label', 'Hide images and videos in recipe steps');
        }
      });

      // Select main image with thumbnial click.
      $('.quickview-thumbnail', context).click(function(e) {
        e.preventDefault();
        var slideIndex = e.currentTarget.dataset.slideIndex;
        selectMainImage(slideIndex);
      });

      // Init recipe thumbnail slider.
      var recipeSlider = new Swiper(".recipe-slider", {
        spaceBetween: 10,
        slidesPerView: 3,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          960: {
            spaceBetween: 20,
          },
        }
      });

      // Allow keyboard users to select thumbnails.
      $(once('recipeSelect', '.recipe-slider .swiper-slide')).each(function () {
        let $slide = $(this);
        $slide.on("keydown", (e) => {
          if (e.keyCode !== 13 && e.keyCode !== 32) return;
          var slideIndex = e.currentTarget.dataset.slideIndex;
          if (slideIndex) {
            selectMainImage(slideIndex);
          };
        });
      });

      // Helper function to select main image.
      function selectMainImage(slideIndex) {
        $thumbnailImage = $(`.quickview-thumbnail[data-slide-index='${slideIndex}']`);
        $mainImage = $(`.quickview-main-image[data-main-index='${slideIndex}']`);

        if ($thumbnailImage.length && $mainImage.length) {
          $('.quickview-thumbnail').attr('aria-current', 'false');
          $thumbnailImage.attr('aria-current', 'true');

          $('.quickview-main-image').hide().removeClass('active');
          $mainImage.show().addClass('active');
        }
      }

    }
  };
})(jQuery, Drupal);
